import {AxiosError, AxiosResponse} from 'axios';
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {Article} from '../types';
import {useSingleNewsQuery} from './useSingleNewsQuery';
import {useAccessToken} from '@eksab/hooks';

type Params = {
  slug: string;
};

export function useToggleNewsLikeMutation(options?: UseMutationOptions<{data: Article}, AxiosError, Params>) {
  const queryClient = useQueryClient();

  const isLoggedIn = !!useAccessToken()?.data;
  return useMutation<{data: Article}, AxiosError, Params>(
    (params) => api.post<Params, AxiosResponse<{data: Article}>>(`v3/news/${params.slug}/like`).then((res) => res.data),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.setQueryData(useSingleNewsQuery.queryKey(data.data.slug, isLoggedIn), data.data);
      },
    },
  );
}
